"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileExtension = void 0;
exports.fileExtension = /\.[0-9a-zA-Z]+$/i;
